import httpClient from "@/services/http-client";
import { GetCurrentUserResponse, UserLoginRequest, UserLoginResponse } from "./user-models";
import { ApiResponse } from "../response-models";

export class UserService {
    login = async (request: UserLoginRequest): Promise<UserLoginResponse> => {
        const { data } = await httpClient.postForm<ApiResponse<UserLoginResponse>>("/api/users/login", {
            username: request.username,
            password: request.password,
        });
        return data.data;
    }

    logout = async (): Promise<boolean> => {
        await httpClient.post("/api/users/logout");
        return true;
    }

    current = async (): Promise<GetCurrentUserResponse> => {
        const { data } = await httpClient.get<ApiResponse<GetCurrentUserResponse>>("/api/users/_current");
        return data.data;
    }
}

const userService = new UserService();
export default userService;